import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=39f7485c&scoped=true"
import script from "./AddPartner.vue?vue&type=script&lang=ts"
export * from "./AddPartner.vue?vue&type=script&lang=ts"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=39f7485c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7485c",
  null
  
)

export default component.exports